import axios from "axios";
import { store } from "./../../store";

const API_URL = 'https://reliance-api.blubirch.com';
//time extend
const IS_QA_SERVER = false 
const private_market_place = "https://marketplace.b4traders.com/Reliance_Digital/";
const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

securedAxiosInstance.interceptors.request.use((config) => {
  const method = config.method.toUpperCase();
  if (method !== "OPTIONS") {
    config.headers = {
      ...config.headers,
      Authorization: store.state.authorization,
      Filter: store.state.current_warehouse,
    };
  }
  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

securedAxiosInstance.interceptors.response.use(null, (error) => {
  if (
    error.response &&
    error.response.config &&
    error.response.status === 401
  ) {
    plainAxiosInstance
      .delete("/api/v1/logout")
      .then((response) => {
        store.commit("unsetCurrentUser");
        location.replace("/");
      })
      .catch(() => {
        store.commit("unsetCurrentUser");
        location.replace("/");
        this.$toast.error("Error in updating distribution_center");
      });
  } else {
    return Promise.reject(error);
  }
});

let secured = securedAxiosInstance
let plain =  plainAxiosInstance
export { secured, plain, securedAxiosInstance, plainAxiosInstance, IS_QA_SERVER, API_URL, private_market_place};
